export default "<p>inventarios works!</p>\n"